export default __webpack_public_path__ + "static/iPhoneFrameFullWhite-b28e29313a6bf13c2519a96a56f216cf.png";